import { useMutation } from "@tanstack/react-query";
import { CompanyOpportunityInterviewSchema } from "./schema";
import { useAuth0 } from "@auth0/auth0-react";
import request from "@/lib/api/handler";
import { CompanyInterview } from "@/types";
import { QueryKeys, useInvalidateQuery } from "@/queries/utils";
import { toast } from "sonner";

const useCompanyInterviewMutation = (
  jobOpeningId: string,
  interviewId?: string,
  candidateId?: string,
  onSuccess?: (result: CompanyInterview) => void,
) => {
  const invalidate = useInvalidateQuery();
  const { getAccessTokenSilently } = useAuth0();

  return useMutation({
    mutationFn: async (data: CompanyOpportunityInterviewSchema) => {
      const token = await getAccessTokenSilently();

      if (interviewId) {
        return request<CompanyInterview>({
          method: "PATCH",
          token,
          path: `/api/interview/${interviewId}`,
          body: JSON.stringify(data),
        });
      } else {
        return request<CompanyInterview>({
          method: "POST",
          token,
          path: "/api/interview",
          body: JSON.stringify({
            ...data,
            candidateId,
            jobOpeningId,
          }),
        });
      }
    },
    onError() {
      toast.error(`Failed to updated opportunity`);
    },
    async onSuccess(data) {
      toast.success(`Opportunity updated successfully!`);
      onSuccess?.(data);

      await invalidate(QueryKeys.companyOpportunities);
      await invalidate(QueryKeys.companyOpportunity(jobOpeningId ?? ""));
      await invalidate(QueryKeys.adminJobDetails(jobOpeningId ?? ""));
    },
  });
};

export default useCompanyInterviewMutation;
